module.exports = __webpack_public_path__ + "assets/img/safety.1970630c.jpg";